import Service from './Service';

class ListService extends Service {
    getList(listType, params) {
        return this.get(`${listType}?`, params);
    }
}

export default new ListService('/api/lists/');
